import React from "react";

const MergeModalCloseIcon = props => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      fill="none"
      className="absolute right-0 text-xl cursor-pointer"
      onClick={() => props?.setVisible(false)}
    >
      <rect width={23} height={23} x={0.5} y={0.5} fill="#fff" rx={11.5} />
      <rect width={23} height={23} x={0.5} y={0.5} stroke="#E2E8F0" rx={11.5} />
      <path
        stroke="#334155"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="m14.625 9.375-5.25 5.25M9.375 9.375l5.25 5.25"
      />
    </svg>
  );
};

export default MergeModalCloseIcon;
